export const AUTH_AUDIENCE = 'https://webpart-store-client-portal-api/'
export const AUTH_DOMAIN = 'yorcloud.eu.auth0.com'
export const AUTH_CLIENT_ID = 'MAGaUnUAlhg26j9N94a5spbjEgMeOprA'
export const STRIPE_PUBLIC_KEY = 'pk_test_sblu1nymAWEg8OaUfyxHz0Xi007ekQg9Bo'
export const DOWNLOADS = [
    {
        title: "Free Bundle",
        description: "Call Me, Welcome, Search, Mail To",
        version: "1.0.0.6",
        file_name: "webpart.store free pack webparts.sppkg"
    }
]